import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import Live from "../../assets/images/instagram-live 1.png";
import Approved from "../../assets/images/approved.png";
import Pending from "../../assets/images/pending 2.png";
import Add from "../../assets/images/UpcomingEvent/add 1.png";
import axios from "axios";

const PromoStarNav = () => {
  const [live, setLive] = useState("");
  const [approved, setApproved] = useState("");
  const [pending, setPending] = useState("");
  const [reject, setReject] = useState("");

  //Fetch Approved LiveChat
  useEffect(() => {
    axios.get(`/api/star/promoVideo/count`).then((res) => {
      if (res.status === 200) {
        setLive(res.data.liveTotal);
        setApproved(res.data.approveTotal);
        setPending(res.data.pendingTotal);
        setReject(res.data.rejectTotal);
      }
    });
  }, []);

  return (
    <>
      <div className="mb-3 row">
        <div
          title="Live Now"
          className="col-md-3 align-items-center justify-content-center "
        >
          <div className="card card-bg nav-body-dashboard mb-2">
            <div className="card-body  align-items-center">
              <center>
                <tr>
                  <td className="livechat-card-td">
                    <img src={Live} className="img-top" alt="..." />
                  </td>
                  <td className="livechat-card-td">
                    <small className="p-3 fw-bold rounded-1 text-warning textFontResult">
                      {live}
                    </small>
                  </td>
                </tr>
              </center>
            </div>
            <Link
              to="/superstar/live/promoVideo"
              className="card-footer livechat-card-footer"
            >
              <button
                className="livechat-card-footer"
                data-bs-toggle="collapse"
                data-bs-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                {" "}
                Live
              </button>
            </Link>
          </div>
        </div>
        <br />
        <div
          title="Live Now"
          className="col-md-3 align-items-center justify-content-center "
        >
          <div className="card card-bg nav-body-dashboard mb-2">
            <div className="card-body  align-items-center">
              <center>
                <tr>
                  <td className="livechat-card-td">
                    <img src={Pending} className="img-top" alt="..." />
                  </td>
                  <td className="livechat-card-td">
                    <small className="p-3 fw-bold rounded-1 text-warning textFontResult">
                      {pending}
                    </small>
                  </td>
                </tr>
              </center>
            </div>
            <Link
              to="/superstar/pending/promoVideo"
              className="livechat-card-footer"
            >
              <button
                className="card-footer livechat-card-footer"
                data-bs-toggle="collapse"
                data-bs-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                Pending
              </button>
            </Link>
          </div>
        </div>
        <br />
        <div
          title="Live Now"
          className="col-md-3 align-items-center justify-content-center "
        >
          <div className="card card-bg nav-body-dashboard mb-2">
            <div className="card-body  align-items-center">
              <center>
                <tr>
                  <td className="livechat-card-td">
                    <img src={Approved} className="img-top" alt="..." />
                  </td>
                  <td className="livechat-card-td">
                    <small className="p-3 fw-bold rounded-1 text-warning textFontResult">
                      {approved}
                    </small>
                  </td>
                </tr>
              </center>
            </div>
            <Link
              to="/superstar/approved/promoVideo"
              className="livechat-card-footer"
            >
              <button
                className="card-footer livechat-card-footer"
                data-bs-toggle="collapse"
                data-bs-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                Approved
              </button>
            </Link>
          </div>
        </div>
        <br />
        <div
          title="Live Now"
          className="col-md-3 align-items-center justify-content-center "
        >
          <div className="card card-bg nav-body-dashboard mb-2">
            <div className="card-body  align-items-center">
              <center>
                <tr>
                  <td className="livechat-card-td">
                    <img src={Add} className="img-top" alt="..." />
                  </td>
                  <td className="livechat-card-td">
                    <small className="p-3 fw-bold rounded-1 text-warning textFontResult"></small>
                  </td>
                </tr>
              </center>
            </div>
            <Link
              to="/superstar/upload/promoVideo"
              className="livechat-card-footer"
            >
              <button
                className="card-footer livechat-card-footer"
                data-bs-toggle="collapse"
                data-bs-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                {" "}
                Add Session
              </button>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default PromoStarNav;
